"use strict";
/// THIS IN NOT THE SCHEMA
/// Schema is stored in the Profile service.
/// This is the expected output for what the profile service will return when a profile is requested.
/// Update the profile service first.
Object.defineProperty(exports, "__esModule", { value: true });
